import { Box } from '@palmetto/palmetto-components';

import EventBy from './EventBy';

const SabalUserDeleted = ({ event }: { event: any }) => {
  return (
    <Box display="block">
      <EventBy event={event} /> removed a user <strong>{event.data.username}</strong>
    </Box>
  );
};

export default SabalUserDeleted;
